import { configureStore } from '@reduxjs/toolkit'
import { baseApi } from 'api'

import { authReducer } from './auth'
import { customerAddReducer } from './customerAdd'
import { globalReducer } from './global.slice'
import { orderAddReducer } from './orderAdd'
import { orderListReducer } from './orderList.slice'
import { versionSlice } from './version.slice'

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    globalReducer,
    authReducer,
    customerAddReducer,
    orderAddReducer,
    orderListReducer,
    version: versionSlice.reducer
  },
  // @ts-ignore
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(baseApi.middleware)
})

export type TypeRootState = ReturnType<typeof store.getState>
